import React from "react";
import { useSpring, animated } from "react-spring";

const FadeInComponent = ({ children }) => {
  const fadeInProps = useSpring({ opacity: 1, from: { opacity: 0 } });

  return (
    <div className="fade-in">
      <animated.div style={{ ...fadeInProps, width: '100%' }}>{children}</animated.div>
    </div>
  );
};

export default FadeInComponent;
